import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class OutgoingLabelService {
  /**
   * Base URL for controller
   * @type {string}
   */
  private url: string = 'outgoing_labels';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Build base URL for controller under outgoing jobs
   * @param  {number} outgoingJobId Id of outgoing job
   * @return {string}               URL
   */
  buildOutgoingLabelsUrl(outgoingJobId: number): string {
    return `/outgoing_jobs/${outgoingJobId}/${this.url}`;
  }

  /**
   * Restart outgoing label processing
   * @param  {number}       id            Id of outgoing label
   * @param  {number}       outgoingJobId Id of outgoing job
   * @return {Promise<any>}               Server response
   */
  restart(id: number, outgoingJobId: number): Promise<any> {
    return this.httpClient.put(`${this.buildOutgoingLabelsUrl(outgoingJobId)}/${id}/restart.json`, {});
  }

  /**
   * Send outgoing label for processing
   * @param  {number}       id            Id of outgoing label
   * @param  {number}       outgoingJobId Id of outgoing job
   * @return {Promise<any>}               Server response
   */
  sendout(id: number, outgoingJobId: number): Promise<any> {
    return this.httpClient.put(`${this.buildOutgoingLabelsUrl(outgoingJobId)}/${id}/sendout.json`, {});
  }
}
